<div class="loading-view" *ngIf="isLoading"></div>
